"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PutBucketReplicationInput_1 = require("./PutBucketReplicationInput");
var PutBucketReplicationOutput_1 = require("./PutBucketReplicationOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.PutBucketReplication = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "PutBucketReplication",
    http: {
        method: "PUT",
        requestUri: "/{Bucket}?replication"
    },
    input: {
        shape: PutBucketReplicationInput_1.PutBucketReplicationInput
    },
    output: {
        shape: PutBucketReplicationOutput_1.PutBucketReplicationOutput
    },
    errors: []
};
//# sourceMappingURL=PutBucketReplication.js.map